import type {
    GA4CancellationPolicyType,
    GTMEcommerceReturnType,
    GTMItemData,
    GTMItemsReturnType
} from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';
import { calculateValue } from '../GTMHelpers';

interface GTMViewItemEcommerceReturnType {
    value: number;
    items: Omit<GTMItemsReturnType, 'index'>[];
}

type GTMViewItemReturnType = GTMEcommerceReturnType<GTMViewItemEcommerceReturnType>;

export interface GTMViewItemModelData extends GTMItemData {
    cancellationPolicy: GA4CancellationPolicyType;
}

export default class GTMViewItemModel extends GTMBaseModel {
    public static parseToGTMData({
        id,
        title,
        country,
        region,
        department,
        place,
        discount,
        pricePerNight,
        instantBooking,
        quantity = 1,
        cancellationPolicy
    }: GTMViewItemModelData): GTMViewItemReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'view_item',
            ecommerce: {
                value: pricePerNight ? calculateValue(pricePerNight, quantity) : 0,
                items: [
                    {
                        item_id: id,
                        item_name: title,
                        item_category: country,
                        item_category2: region,
                        item_category3: department,
                        item_category4: place,
                        discount,
                        quantity,
                        price: pricePerNight,
                        instant_booking: instantBooking,
                        cancellation_policy: cancellationPolicy
                    }
                ]
            }
        };
    }
}
